<template>
    <div class="card" @click="showHeat" 
        :class="{
            disabled: isUnavailable
        }">    
        <div class="heat-icon">
            <img :src="eventTypeImage">
        </div>    
        <div>
            <div class="icon" :class="{
            'none': event.state == 0,
            'start-list': event.state == 1,
            'in-progress': event.state == 2,
            'finished': event.state == 3,
        }">{{ shortTitle }} - {{ event.className }}</div>
            <div>{{ getEventInfo }}</div>
        </div>      
    </div>
</template>

<script>

import { mapMutations, mapActions, mapGetters } from 'vuex';
import glMut from '../store/mutations/global';
import glAct from '../store/actions/global';

export default {
    name: "event-card",
    props: {
        event: {
            required: true
        },
    },
    methods: {
        ...mapMutations([glMut.SETSELECTEDHEAT]),
        showHeat(competition){
            this.SETSELECTEDHEAT({id:this.event.id, heat: undefined});
            this.$router.push('/competition/events/event/');
        }
    },
    computed: {
        ...mapGetters(['ConnectionState']),
        shortTitle(){
            if(this.event.eventName.length <= 30){
                return this.event.eventName;
            }
            return this.event.eventName.substring(0, 27) + "...";
        },
        eventTypeImage(){
            return require(`../../assets/img/eventtype/${this.event.type}.png`);
        },        
        getEventInfo() {
            const date = new Date(this.event.startTime);
            const group = this.event.squadGroupName ? this.event.squadGroupName : '';
            return `${this.getTime} ${group}`;
        },
        getTime() {
            const date = new Date(this.event.startTime);
            let h = date.getHours();
            h = (h < 10 ? '0' : '') + h;
            let m = date.getMinutes();
            m = (m < 10 ? '0' : '') + m;
            return `${h}:${m}`;
        },
        isUnavailable(){
            return this.ConnectionState === 0 && !JSON.parse(localStorage.getItem(this.event.id));
        }
    },
}
</script>

<style lang="scss" scoped>

    @import "../../assets/styles/_globals";

    .card {
        border: solid 1px $seltec_color;
        border-top: 0px;
        width:100%;
        background-color:$prim_bg_color;
        height: $height_default;
        padding-left: $spacer_s / 2;
        font-size: 10px;
        display: flex;
        align-items: center;
        box-sizing: border-box;

        .heat-icon {
            width: $height_default;            
            min-width: $height_default;
            img {
                max-width: $height_s;
                max-height: $height_s;
            }
        }

        .icon::after {
            font: normal normal normal 14px/1 "Material Design Icons";
            padding-left:10px;
        }
        .none::after {
            content: "\F0F08";
        }
        .start-list::after {
            content: "\F027B";
            color: $prim_aleart_light_color;
        }
        .in-progress::after {
            content: "\F040B";
            color: $prim_warning_color;
        }
        .finished::after {
            content: "\F023C";
        }

        div {  
            div {                
                overflow: hidden;
                text-overflow: ellipsis;
            }          

             div:first-of-type {
                font-size: 14px;
                font-weight: bold;
            }
        }

        div {            
            width: 65%;
            white-space: nowrap;
        }
    }

    .card:first-of-type {
        border-top: solid 1px $seltec_color;
    }
    
    .card:hover {
        background-color:$sec_color_dark;
        cursor: pointer;
    }

    .card:active {
        background-color:$seltec_color;
        cursor: pointer;
    }

    .card::after {
        font: normal normal normal 24px/1 "Material Design Icons";
        content:"\F0342";
        margin-left: auto;
        padding-right: 10px;
    }

    .disabled {
        opacity: 0.5;
    }

    @media screen and (max-width: $body_max_width) {       
        .card {
            border:0px;
            
        border-bottom: solid 1px $seltec_color;
        }
    }

    

    @media screen and (max-width: 400px) {       
        .heat-icon {
            display:none;
        }

        .card > div:nth-child(2) {            
            width: 80%!important;
        }
    }
</style>